<svg class="{$$props.class}" viewBox="0 0 480 480">
  <path
    fill="currentColor"
    d="M456 240h-8V72a40 40 0 00-40-40H72a40 40 0 00-40 40v120h-8a24 24 0 00-24
    24v208a24 24 0 0024 24h304a8 8 0 008-8 40 40 0 00-40-40h-24v-48h96v72a24 24
    0 0024 24h64a24 24 0 0024-24V264a24 24 0 00-24-24zM176 424a8 8 0 01-8 8H24a8
    8 0 01-8-8v-8h160v8zm0-24H16V216a8 8 0 018-8h144a8 8 0 018 8v184zm120 16a24
    24 0 0122.6 16h-128a23.7 23.7 0 001.4-8v-8h104zm-104-16v-48h16v48h-16zm32
    0v-48h32v48h-32zm144-64H192v-48h176v48zm0-72v8H192v-56c0-3.8-1-7.5-2.7-10.9l.4-.2
    79.2-79.2a8 8 0 00-11.4-11.4l-79.2 79.2-.4.7a23.7 23.7 0 00-9.9-2.2H48V72a24
    24 0 0124-24h336a24 24 0 0124 24v168h-40a24 24 0 00-24 24zm96 160a8 8 0 01-8
    8h-64a8 8 0 01-8-8v-8h80v8zm0-24h-80V264a8 8 0 018-8h64a8 8 0 018 8v136z" />
  <path
    fill="currentColor"
    d="M95.6 289.4a8 8 0 00-11.3 0l-34 33.9a8 8 0 1011.4
    11.3l33.9-34c1.4-2.4-1.4-7.1 0-11.2zm47.8 0a8 8 0 00-11.1 0l-34 33.9a8 8 0
    1011.4 11.3l33.9-34a8 8 0 00-.2-11.2zm174-175a8 8 0 00-11 0L227 193.4a8 8 0
    1011.4 11.4l79.2-79.2a8 8 0 00-.2-11.4zM440.9 311a8 8 0 00-11.1 0L407
    333.7a8 8 0 1011.3 11.3l22.7-22.7a8 8 0 00-.2-11.3zm-200.6-7h-.1a8 8 0 000
    16 8 8 0 000-16zM256 64h-32a8 8 0 000 16h32a8 8 0 000-16z" />
</svg>
